


































import { defineComponent } from '@vue/composition-api';

const CommonConfirmDialog = defineComponent({
  // setup() {},
  props: {
    title: {
      type: String,
      default() { return ''; },
    },
    text: {
      type: String,
      default() { return ''; },
    },
    mutation: {},
    invertColor: {
      type: Boolean,
      default() { return false; },
    },
    oneButton: {
      type: Boolean,
      default() { return false; },
    },
  },
});

export default CommonConfirmDialog;
